import httpService from "Root/api/httpService";
export const apiGetDiscountText = async () => {
    const endpoint = "/api/get-discount-text/";
    const { discount_text, discount_banner } = await httpService.get(endpoint);
    return { discount_text, discount_banner };
};
export const apiGetRecurringString = () => {
    const endpoint = "/api/get-recurring-string/";
    return httpService.get(endpoint);
};
export const apiGetUserCart = () => {
    const endpoint = "/api/v2/get-user-cart/";
    return httpService.get(endpoint);
};
export const apiGetCheckoutFlow = () => {
    const endpoint = `/api/v2/get-checkout-flow/${window.location.search}`;
    return httpService.get(endpoint);
};
export const apiGetFlowExperience = () => {
    const endpoint = "/api/v2/get-ab-status/flow-experience/";
    return httpService.get(endpoint);
};
export const apiGetPreferredPayment = () => {
    const endpoint = "/api/v2/preferred-payment/";
    return httpService.get(endpoint);
};
export const apiGetCartItems = () => {
    const endpoint = "/api/items/";
    return httpService.get(endpoint);
};
export const apiGetPricingSummary = (key, isOtb) => {
    const endpoint = `/api/get-pricing-summary/?shippingSpeed=${key}` + (isOtb ? "&otb=1" : "");
    return httpService.get(endpoint);
};
export const apiV2PricingSummary = (shippingSpeed, isOtb) => {
    const endpoint = `/api/v2/pricing-summary/?shippingSpeed=${shippingSpeed}` + (isOtb ? "&otb=1" : "");
    return httpService.get(endpoint);
};
export const apiGetAllAvailableFlavors = () => {
    const endpoint = "/api/get-flavors-for-profile/"; // common for checkout and profile
    return httpService.get(endpoint);
};
export const apiGetSubscriptionString = () => {
    const endpoint = "/api/v2/subscription-string/";
    return httpService.get(endpoint);
};
export const apiGetPostPurchaseQuestions = () => {
    const endpoint = "/api/quiz/post-purchase-questions/";
    return httpService.get(endpoint);
};
export const apiGetUserAddress = () => {
    const endpoint = "/api/user-address/";
    return httpService.get(endpoint);
};
export const apiGetShippingMethod = () => {
    const endpoint = "/api/shipping-methods/";
    return httpService.get(endpoint);
};
export const apiGetStarterKitEligibility = () => {
    const endpoint = "/api/get-starter-kit-eligibility/";
    return httpService.get(endpoint);
};
export const apiGetPersonalizationsData = () => {
    const endpoint = `/api/v2/get-personalized-checkout-copy/${window.location.search}`;
    return httpService.get(endpoint);
};
export const apiGetIngredientInfo = (key) => {
    const endpoint = `/api/v2/get-ingredient-info/?product=${key}&new=True`;
    return httpService.get(endpoint);
};
export const apiGetIngredientInfoSearch = (keys, fetchAll) => {
    const endpoint = `/api/v2/get-ingredient-info/?new=True${fetchAll ? "&product=all" : `&search=${keys}`}`;
    return httpService.get(endpoint);
};
export const apiGetVariableStarterKitPrices = () => {
    const endpoint = "/api/get-variable-starter-kit-prices/";
    return httpService.get(endpoint);
};
export const apiGetProductInfo = (key) => {
    const endpoint = `/api/get-product-info/?product=${key}`;
    return httpService.get(endpoint);
};
export const apiGetProductInfoMock = (key) => {
    const endpoint = `/api/get-product-info-mock/?product=${key}`;
    return httpService.get(endpoint);
};
export const apiGetPersonalizedRecommendation = () => {
    const endpoint = "/api/v2/get-personalized-recommendation/";
    return httpService.get(endpoint);
};
export const apiGetPersonalizedReviews = () => {
    const endpoint = "/api/v2/personalized-reviews/";
    return httpService.get(endpoint);
};
export const apiGetReviews = () => {
    const endpoint = "/api/v2/get-reviews/";
    return httpService.get(endpoint);
};
export const apiGetHowToLPData = () => {
    const endpoint = "/api/v2/get-how-to-use-data/";
    return httpService.get(endpoint);
};
export const apiGetStarterKitTestStatus = () => {
    const endpoint = "/api/get-starter-kit-test-status/";
    return httpService.get(endpoint);
};
export const apiGetOptionalFlow = () => {
    const endpoint = "/api/get-optional-flow/";
    return httpService.get(endpoint);
};
export const apiGetStarterKitCart = () => {
    const endpoint = "/api/get-starter-cart/";
    return httpService.get(endpoint);
};
export const apiGetStarterKitIcons = () => {
    const endpoint = "/api/get-starter-icons/";
    return httpService.get(endpoint);
};
export const apiGetUpsellInfo = () => {
    const endpoint = "/api/get-upsell-info/";
    return httpService.get(endpoint);
};
export const apiGetUpsellItem = () => {
    const endpoint = "/api/v2/upsell-item/";
    return httpService.get(endpoint);
};
export const apiGetStripeKeys = () => {
    const endpoint = "/api/stripe-keys/";
    return httpService.get(endpoint);
};
export const apiGetRDVideoInfo = () => {
    const endpoint = "/api/v2/get-rd-video/";
    return httpService.get(endpoint);
};
export const apiGetPayPalId = () => {
    const endpoint = "/api/paypal-client-id/"; // paypall btn
    return httpService.get(endpoint);
};
export const apiAddAdditionalItemToNextOrder = (body) => {
    const endpoint = "/api/add-additional-item-to-next-order/";
    return httpService.post(endpoint, body);
};
export const apiRemoveLineItem = (body) => {
    const endpoint = "/api/remove-line-item/";
    return httpService.post(endpoint, body);
};
export const apiUpdateItems = (body) => {
    const endpoint = "/api/items/";
    return httpService.post(endpoint, body);
};
export const apiSendMessageToRD = (body) => {
    const endpoint = "/users/askMatt/";
    return httpService.post(endpoint, body);
};
export const apiUpdateItemsQuantity = (body) => {
    const endpoint = "/api/v2/update-item-quantity/";
    return httpService.post(endpoint, body);
};
export const apiUpdateUserAddress = (body) => {
    const endpoint = "/api/user-address/";
    return httpService.post(endpoint, body);
};
export const apiMakeStarterKitOptional = (body) => {
    const endpoint = "/api/make-starter-kit-optional/";
    return httpService.post(endpoint, body);
};
export const apiCompleteOrderForIntent = (body) => {
    const endpoint = "/users/complete_order_for_intent/";
    return httpService.post(endpoint, body);
};
export const apiSignupForNewsletter = (body) => {
    const endpoint = "/api/signup_for_newsletter/";
    return httpService.post(endpoint, body); // tested 405 Method Not Allowed
};
export const apiApplyPromo = (body) => {
    const endpoint = "/api/v2/apply-promo/";
    return httpService.post(endpoint, body);
};
export const apiRemovePromo = (body) => {
    const endpoint = "/api/v2/remove-promo/";
    return httpService.post(endpoint, body);
};
export const apiCreatePaymentIntent = (body) => {
    const endpoint = "/users/create_payment_intent/";
    return httpService.post(endpoint, body);
};
export const apiAddBraintreeCustomer = (body) => {
    const endpoint = "/api/v2/add-braintree-customer/";
    return httpService.post(endpoint, body);
};
export const apiCompletePaypalOrder = (body) => {
    const endpoint = "/api/v2/complete-order-for-paypal/";
    return httpService.post(endpoint, body);
};
export const apiCompleteFreeOrder = () => {
    const endpoint = "/users/complete-free-order/";
    return httpService.post(endpoint, {});
};
export const apiCreatePaypalToken = (body) => {
    const endpoint = "/api/create-paypal-token/";
    return httpService.post(endpoint, body);
};
export const apiStripe2braintree = (body) => {
    const endpoint = "/users/stripe2braintree/"; // paypall btn
    return httpService.post(endpoint, body);
};
export const apiApplePayShipping = (body) => {
    const endpoint = "/api/v2/apple-pay-shipping/";
    return httpService.post(endpoint, body);
};
export const apiHandlePreworkoutUpsell = (body) => {
    const endpoint = "/api/v2/handle-pw-upsell/";
    return httpService.post(endpoint, body);
};
export const apiGetSavedProgramDiscount = () => {
    const endpoint = "/api/v2/saved-program-discount/";
    return httpService.get(endpoint);
};
export const passwordResetForDuplicateAccount = () => {
    const endpoint = "/api/v2/password-reset/";
    return httpService.post(endpoint, {});
};
